import {
  DOWNLOAD_COUNT,
  ALACARTE_PAGE_LOADER,
  SET_ALACARTE_PAGE_DATA,
} from "../actionTypes";

const initialState = {
  loader: false,
  alacartePageData: {},
};

/**
 * Alacarte page reducer.
 *
 * Handles the following actions:
 *  - ALACARTE_PAGE_LOADER: sets the loader state
 *  - SET_ALACARTE_PAGE_DATA: sets the alacarte page data
 *  - DOWNLOAD_COUNT: increments the download count or file view count
 *
 * @param {Object} state current state
 * @param {Object} action action payload
 * @return {Object} new state
 */
const alacarteReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALACARTE_PAGE_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_ALACARTE_PAGE_DATA: {
      return {
        ...state,
        alacartePageData: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          alacartePageData: {
            ...state.alacartePageData,
            fileViewCount: (state.alacartePageData?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          alacartePageData: {
            ...state.alacartePageData,
            downloadCount: (state.alacartePageData?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default alacarteReducer;
